// src/components/Contact.js
import React from 'react';
import './Contact.css';

function Contact() {
  return (
    <section className="contact" id="contact">
      <div className="contact-container">
        <h2>CONTACT</h2>
        <p className="contact-subtitle">Get in touch with us</p>
        
        <div className="contact-info">
          <div className="contact-item">
            <h3>SAMUEL LEDERMAN</h3>
            <a href="mailto:slederman@ezetech.ai">slederman@ezetech.ai</a>
          </div>
          
          <div className="contact-item">
            <h3>CAROLINA BOCKMEULEN</h3>
            <a href="mailto:cbockmeulen@ezetech.ai">cbockmeulen@ezetech.ai</a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;

